module.exports = __webpack_public_path__ + "img/main-m-banner.a170a87e.png";